import ZpFrom from './src/form.vue'
export * from './types'
export default ZpFrom
